import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=2c12eede&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=2c12eede&scoped=true&lang=css&"
import style1 from "./Address.vue?vue&type=style&index=1&id=2c12eede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12eede",
  null
  
)

export default component.exports